/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
// @ts-nocheck
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.releaseFocus = null;
    this.querySelector("#CartDrawer-Overlay")?.addEventListener(
      "click",
      this.close.bind(this),
    );
  }

  get dialog() {
    return this.querySelector(".drawer__wrapper");
  }

  open(trigger) {
    setTimeout(() => {
      this.classList.add("animate", "active");
      this.trapFocus(trigger);
    });
    if (window.lenis && typeof window.lenis.stop === "function") {
      window.lenis.stop();
    }
    document.documentElement.style.overflow = "hidden";
    window.deskCartUpsellEnforceEligibility?.();
  }

  close() {
    this.classList.remove("active");
    if (window.lenis && typeof window.lenis.stop === "function") {
      window.lenis.start();
    }
    document.documentElement.style.overflow = "";
    if (this.releaseFocus) {
      this.releaseFocus();
      this.releaseFocus = null;
    }
  }

  trapFocus(trigger) {
    if (this.releaseFocus || !window.DeskA11y || !this.dialog) return;
    this.releaseFocus = window.DeskA11y.trapFocus(this.dialog, {
      onEscape: () => this.close(),
      initialFocus: ".drawer__close",
      returnFocusTo: trigger,
    });
  }

  captureFocus() {
    const active = document.activeElement;
    if (!this.dialog || active === this.dialog || !this.dialog.contains(active)) return null;
    const anchor = active.closest("[id]");
    const upsell = active.closest(".upsells-list__li");
    const upsellGroup = upsell && upsell.closest(".mobile-upsells") ? ".mobile-upsells" : ".upsells-list";
    const upsellState = upsell
      ? {
          upsellGroup,
          upsellIndex: Array.from(this.dialog.querySelectorAll(`${upsellGroup} .upsells-list__li`)).indexOf(upsell),
        }
      : {};
    if (!anchor || !this.dialog.contains(anchor)) return { anchorId: null, ...upsellState };
    return {
      anchorId: anchor.id,
      isAnchor: anchor === active,
      name: active.getAttribute("name"),
      ...upsellState,
    };
  }

  upsellFallback(focusState) {
    if (!focusState.upsellGroup || !window.DeskA11y || !this.dialog) return null;
    const rows = this.dialog.querySelectorAll(`${focusState.upsellGroup} .upsells-list__li`);
    const row = rows[Math.min(focusState.upsellIndex, rows.length - 1)];
    return row ? window.DeskA11y.getFocusable(row)[0] || null : null;
  }

  restoreFocus(focusState) {
    const dialog = this.dialog;
    if (!focusState || !dialog || dialog.contains(document.activeElement)) return;
    const anchor = focusState.anchorId && document.getElementById(focusState.anchorId);
    let target = null;
    if (anchor && dialog.contains(anchor)) {
      if (focusState.isAnchor) target = anchor;
      else if (focusState.name) target = anchor.querySelector(`[name="${CSS.escape(focusState.name)}"]`);
      if (!target && window.DeskA11y) target = window.DeskA11y.getFocusable(anchor)[0];
    }
    if (!target) target = this.upsellFallback(focusState);
    (target || dialog.querySelector(".drawer__close") || dialog).focus({ preventScroll: true });
  }

  resetAtcButton() {
    $(".product-single__add-to-cart").find(".desk_btn_content").css('opacity', '1');
    $(".product-single__add-to-cart").find(".desk_btn_loader").css('opacity', '0');
    $("[is-sticky-atc]").find(".desk_btn_content").css('opacity', '1');
    $("[is-sticky-atc]").find(".desk_btn_loader").css('opacity', '0');
    $('.upsell_mobile_cart__button').removeClass('loading');
  }

  updateDrawer() {
    fetch(window.Shopify.routes.root + "?sections=desk_cart-drawer")
      .then((response) => response.json())
      .then((sections) => {
        const html = sections["desk_cart-drawer"];
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, "text/html");
        const newDrawer = doc.querySelector("#CartDrawer .drawer__wrapper");
        const currentDrawer = document.querySelector(
          "#CartDrawer .drawer__wrapper",
        );

        const focusState = this.captureFocus();
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }

        const newCartDrawer = doc.querySelector("cart-drawer");
        const currentCartDrawer = document.querySelector("cart-drawer");
        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.classList.toggle(
            "is-empty",
            newCartDrawer.classList.contains("is-empty"),
          );
        }

        fetch(window.Shopify.routes.root + "cart.js")
          .then((r) => r.json())
          .then((cart) => {
            const visibleCount = window.deskVisibleCartCount
              ? window.deskVisibleCartCount(cart)
              : cart.item_count;
            const el = document.querySelector(
              "#header-icons .cart-button__count",
            );
            if (el) {
              el.querySelector(".cart-button__count-number").textContent =
                visibleCount;
              el.style.display = visibleCount > 0 ? "flex" : "none";
            }
            syncCartCountBubbles(visibleCount);

            const purge = window.deskCartUpsellPurgeIfAlone
              ? window.deskCartUpsellPurgeIfAlone(cart)
              : null;
            if (purge) purge.always(() => window.refreshCartDrawer());
          })
          .catch(() => {});

        document.querySelector("#cart-drawer")?.classList.add("active");
        if (window.lenis && typeof window.lenis.stop === "function")
          window.lenis.stop();
        document.documentElement.style.overflow = "hidden";
        if (this.releaseFocus) {
          this.restoreFocus(focusState);
        } else {
          this.trapFocus();
        }
        this.resetAtcButton();
        document.dispatchEvent(new CustomEvent("cart:rendered"));

        // gtag("event", "Cart_Updated_Custom", {
        //   event_category: "User Actions",
        //   event_label: "Cart Updated (Custom)",
        //   value: 1,
        // });
      })
      .catch((error) => {
        console.error("Error Cart Drawer:", error);
        // gtag("event", "Cart_Error_Custom", {
        //   event_category: "User Actions",
        //   event_label: "Cart Error (Custom)",
        //   value: 1,
        // });
      });

    setTimeout(function () {
      window.setStockNote?.();
    }, 1000);
  }
}

customElements.define("cart-drawer", CartDrawer);

function syncCartCountBubbles(itemCount) {
  const count = Number(itemCount) || 0;
  document.querySelectorAll(".desk_header-control__cart").forEach((cart) => {
    let bubble = cart.querySelector(".desk_header-cart-items--count");
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement("span");
        bubble.className = "desk_header-cart-items--count";
        bubble.setAttribute("aria-hidden", "true");
        cart.insertBefore(bubble, cart.firstChild);
      }
      bubble.textContent = count;
    } else if (bubble) {
      bubble.remove();
    }

    const label = cart.dataset.cartLabel;
    if (label) {
      cart.setAttribute(
        "aria-label",
        count > 0 ? `${label}, ${cart.dataset.cartCountLabel}: ${count}` : label,
      );
    }
  });
}

window.syncCartCountBubbles = syncCartCountBubbles;

window.cartDrawer = document.querySelector("cart-drawer");

window.refreshCartDrawer = function () {
  window.cartDrawer?.updateDrawer();
};

function deskRefreshDrawerAfterCartMutation(cart) {
  if (window.deskCartRefreshAfterUpsellPurge) {
    window.deskCartRefreshAfterUpsellPurge(cart, window.refreshCartDrawer);
    return;
  }

  window.refreshCartDrawer();
}

// Serialize cart Ajax mutations. Shopify's cart API is rate-limited (HTTP 429);
// firing concurrent /cart/change|update requests — e.g. rapid remove clicks on a
// slow connection where the drawer hasn't re-rendered yet — gets them rejected and
// leaves items stuck in the loading state. We run one mutation at a time (extra
// requests are refused while one is in flight) and retry a 429 after its
// Retry-After delay.
window.cartMutation = (function () {
  var busy = false;

  function attempt(options, retriesLeft) {
    return $.ajax({
      type: options.method || "POST",
      url: options.url,
      data: options.data,
      contentType: options.contentType,
      dataType: "json",
    }).then(null, function (xhr) {
      if (xhr.status === 429 && retriesLeft > 0) {
        var retryAfter = parseFloat(xhr.getResponseHeader("Retry-After")) || 1;
        var deferred = $.Deferred();
        setTimeout(function () {
          attempt(options, retriesLeft - 1).then(deferred.resolve, deferred.reject);
        }, retryAfter * 1000);
        return deferred.promise();
      }
      return $.Deferred().reject(xhr).promise();
    });
  }

  return {
    isBusy: function () {
      return busy;
    },
    // Returns a jQuery promise, or null when another mutation is already running.
    request: function (options) {
      if (busy) return null;
      busy = true;
      var promise = attempt(options, 3);
      promise.always(function () {
        busy = false;
      });
      return promise;
    },
  };
})();

// Upsell variant selection
$(document).on(
  "click",
  ".upsell_cart__variants .variant:not(.type), .upsell_mobile_cart__variants .variant:not(.type)",
  function () {
    var $el = $(this);
    var $container = $el.closest(
      ".upsell_cart__variants, .upsell_mobile_cart__variants",
    );
    var group = $el.data("name")
      ? $container.find(".variant.color[data-name='" + $el.data("name") + "']")
      : $container.find(".variant");
    group.removeClass("active");
    $el.addClass("active");

    var $product = $el.closest(".upsell_cart, .upsell_mobile_cart");

    // Toggle price-block_upsell-item visibility based on variant id
    var variantId = $el.data("variant");
    if (variantId) {
      var $priceBlocks = $product.find(".price-block_upsell-item");
      $priceBlocks.addClass("hided");
      var $matchedBlock = $priceBlocks
        .filter("[data-id='" + variantId + "']")
        .removeClass("hided");

      // Update image from matching price block's data-variant-img
      var variantImg = $matchedBlock.data("variant-img");
      if (variantImg) {
        $product
          .find(
            ".upsell_cart__image-block #upsell_cart_image, .upsell_mobile_cart__image-block #upsell_cart_image",
          )
          .attr("src", variantImg)
          .attr("srcset", variantImg);
      }
    }

    // Update image from swatch data-image (fallback if no price block image)
    var imageSrc = $el.data("image");
    if (imageSrc && !variantId) {
      var $img = $product.find(
        ".upsell_cart__image-block #upsell_cart_image, .upsell_mobile_cart__image-block #upsell_cart_image",
      );
      var currentSrc = $img.attr("src") || "";
      var cdnIndex = currentSrc.indexOf("shop/");
      if (cdnIndex !== -1) {
        $img.attr("src", currentSrc.substring(0, cdnIndex + 5) + imageSrc);
        $img.attr(
          "srcset",
          ($img.attr("srcset") || "").replace(
            /(shop\/)[^ ]+/g,
            "shop/" + imageSrc,
          ),
        );
      }
    }

    // Update price
    var price = $el.data("price");
    var compared = $el.data("compared");
    var badge = $el.data("badge");
    if (price) $product.find(".price-block__price").html(price);
    if (compared) $product.find(".price-block__sale").html(compared);
    if (badge) $product.find(".price-block__badge").html(badge);
  },
);

$(document).on(
  "click",
  ".upsell_cart__variants .variant.type, .upsell_cart__types .variant.type, .upsell_mobile_cart__variants .variant.type, .upsell_mobile_cart__types .variant.type",
  function () {
    var $el = $(this);
    var $product = $el.closest(".upsell_cart, .upsell_mobile_cart");
    var $colorContainer = $product.find(".upsell_cart__variants, .upsell_mobile_cart__variants");
    var typeName = $el.data("name");

    // Keep the currently selected colour across the type change instead of
    // always snapping back to the first colour.
    var prevColorKey = $colorContainer.find(".variant.color.active").first().data("color");

    $product.find(".variant.type").removeClass("active");
    $el.addClass("active");

    $colorContainer.find(".variant.color").hide().removeClass("active");
    var $group = $colorContainer
      .find(".variant.color[data-name='" + typeName + "']")
      .show();

    // Prefer the same colour in the new type (if it exists and is in stock);
    // otherwise fall back to the first in-stock colour.
    var $inStock = $group.filter(":not(.variantNotInStock)");
    var $match = $();
    if (prevColorKey !== undefined && prevColorKey !== null && prevColorKey !== "") {
      $match = $inStock
        .filter(function () {
          return $(this).data("color") === prevColorKey;
        })
        .first();
    }
    var $first = ($match.length ? $match : $inStock.first()).addClass("active");
    if ($first.length) $first.trigger("click");
  },
);

$(document).on("click", ".upsell_cart__button", function () {
  var $container = $(this).closest(".upsell_mobile_cart, .upsell_cart");
  var $active = $container.find(
    ".variant.color.active, .variant.upsell_item_li.active:not(.type)",
  );
  var variantId = $active.data("variant");
  if (!variantId) return;

  window.deskSetCartAttributes?.();

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(function () {
      window.refreshCartDrawer();
    })
    .catch(function (e) {
      console.error("Upsell add error:", e);
    });
});

// Close cart drawer
$(document).on("click", "#cart-drawer .drawer__close", function () {
  window.cartDrawer.close();
});

// Open cart drawer on header cart button click
$(document).on(
  "click",
  ".desk_header-control__cart",
  function (/** @type {any} */ e) {
    e.preventDefault();
    window.cartDrawer?.open(this);
  },
);

// Cart drawer quantity +/- handler
(function () {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  var updateTimer;
  $(document).on(
    "click",
    "#cart-drawer .cart-quantity .quantity__button",
    function () {
      var $button = $(this);
      var $input = $button.closest("quantity-input").find(".quantity__input");
      var variantId = $input.attr("data-quantity-variant-id");

      if (!variantId || !$input.length) return;

      var isPlus = $button.attr("name") === "plus";
      var currentQty = parseInt($input.val(), 10) || 0;
      var newQty = isPlus ? currentQty + 1 : Math.max(0, currentQty - 1);
      $input.val(newQty);

      var itemIndex = $input.attr("data-index");
      clearTimeout(updateTimer);
      updateTimer = setTimeout(function () {
        // Skip if a cart mutation (e.g. a remove) is in flight; the next
        // interaction will re-sync against the refreshed drawer.
        if (window.cartMutation.isBusy()) return;
        $("#cart-drawer cart-remove-button[data-index='" + itemIndex + "']").addClass("loading");

        window.cartMutation
          .request({
            url: window.Shopify.routes.root + "cart/update.js",
            data: JSON.stringify({ updates: { [variantId]: newQty } }),
            contentType: "application/json",
          })
          .done(function (cart) {
            deskRefreshDrawerAfterCartMutation(cart);
          });
      }, 500);
    },
  );
})();

// Upsells shadow on scroll
function bindUpsellsScroll() {
  var $el = $(".drawer__wrapper .upsells");
  if (!$el.length) return;
  $el.off("scroll.upsellShadow").on("scroll.upsellShadow", function () {
    var atBottom = this.scrollTop + this.clientHeight >= this.scrollHeight - 2;
    $(".desk_side-upsells-shadow").toggle(!atBottom);
  });
  $el.trigger("scroll.upsellShadow");
}

$(document).ready(bindUpsellsScroll);
$(document).on("cart:rendered", bindUpsellsScroll);

// Cart drawer remove-item handler
$(document).on(
  "click",
  "#cart-drawer cart-remove-button .cart-item__remove",
  function (/** @type {any} */ e) {
    e.preventDefault();
    var $btn = $(this);
    var $item = $btn.closest(".cart-item");
    var href = $btn.attr("data-href");
    var lineKey = $item.attr("data-key");
    var line = href
      ? new URLSearchParams(href.split("?")[1] || "").get("line")
      : null;
    if (!lineKey && !line) return;
    // Ignore the click if a cart mutation is already running — prevents the burst
    // of concurrent requests that Shopify rejects with 429.
    if (window.cartMutation.isBusy()) return;
    // the spinner styles hang off cart-remove-button, not the row
    $item.addClass("loading");
    $btn.closest("cart-remove-button").addClass("loading");
    window.cartMutation
      .request({
        url: window.Shopify.routes.root + "cart/change.js",
        data: JSON.stringify(
          lineKey
            ? { id: lineKey, quantity: 0 }
            : { line: Number(line), quantity: 0 },
        ),
        contentType: "application/json",
      })
      .done(function (cart) {
        deskRefreshDrawerAfterCartMutation(cart);
      })
      .fail(function () {
        $item.removeClass("loading");
        $btn.closest("cart-remove-button").removeClass("loading");
      });
  },
);
